import { QueryBuilderEntityConfigType } from '../../../../types';

export const filterEntityOptionsBySearch = (
  entities: QueryBuilderEntityConfigType[],
  search: string
): QueryBuilderEntityConfigType[] => {
  const normalizedSearch = search.trim().toLowerCase();

  if (!normalizedSearch) {
    return entities;
  }

  return entities.filter(
    (entity) =>
      entity.label.toLowerCase().includes(normalizedSearch) ||
      entity.key.toLowerCase().includes(normalizedSearch)
  );
};
